var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ParameterBeforeRepair } from "../../PhysicalPhenomena/DataGridBeforeRepair";
import { ParameterWhileRepair } from "../../PhysicalPhenomena/DataGridWhileRepair";
import { UploadAttachmentAPICall } from "../../services/apiCalls";
import { FileAttachmentComponent } from "../FrequentComponent";
import { Typography } from "@mui/material";
import { DisabledPlusIcon, DisabledTrashIcon, PlusBlueIcon, TrashIcon } from "../../assets/svg";
import { v4 } from "uuid";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
export var PhysicalFormData = [{
        type: FormItemTypes.Custom,
        name: "ParamsBeforeRepairData",
        element: ParameterBeforeRepair,
        columnSize: 12
    }, {
        type: FormItemTypes.Custom,
        name: "ParamsAfterRepairData",
        element: ParameterWhileRepair,
        columnSize: 12
    }, {
        type: FormItemTypes.CardComponent,
        name: "failure/defective part",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.TextInput,
                name: "CauseOfFailure",
                label: "Cause of Failure",
                md: 6,
                multiline: true,
                rows: 4,
                placeholder: "Enter your description",
                validator: function (value) {
                    if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                        return "Description cannot be less than of 10 character.";
                    }
                    else if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                        return "Description can have maximum of 250 character.";
                    }
                }
            }, {
                type: FormItemTypes.TextInput,
                name: "DefectivePartIdentification",
                label: "Defective part identification",
                md: 6,
                multiline: true,
                rows: 4,
                placeholder: "Enter your description",
                validator: function (value) {
                    if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                        return "Description cannot be less than of 10 character.";
                    }
                    else if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                        return "Description can have maximum of 250 character.";
                    }
                }
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "checksheet",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.Typography,
                name: "sub_heading",
                label: "Checksheet filled",
                labelTypographyProps: {
                    fontSize: "base",
                    fontWeight: "strong",
                    color: "text.primary"
                },
                children: "Manage your team members here",
                columnSize: true,
                color: "text.tertiary"
            }, {
                type: FormItemTypes.Attachment,
                name: "ChecksheetFilledAttachments",
                value: null,
                inputProps: {
                    accept: [".xlsx", ".csv"]
                },
                columnSize: 0,
                attachmentButtonProps: {
                    sx: {
                        display: "none"
                    }
                },
                uploadAttachmentAPI: UploadAttachmentAPICall,
                setFieldProps: function (formValues, currentValue) {
                    var result = currentValue === null || currentValue === void 0 ? void 0 : currentValue.find(function (item) { return item.IsDeleted == 0 || (item === null || item === void 0 ? void 0 : item.name); });
                    return {
                        type: FormItemTypes.Attachment,
                        uploadButtonProps: {
                            variant: "text",
                            color: "primary",
                            disabled: result
                        }
                    };
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Custom,
                        name: "ChecksheetFilledAttachments",
                        columnSize: 12,
                        element: FileAttachmentComponent,
                        validator: function (value, state) {
                            var _value$;
                            if ((value === null || value === void 0 || (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.size) > 5 * 1024 * 1024)
                                return "Max file size allowed is 5MB";
                            return "";
                        }
                    }]
            }]
    }];
export var PhysicalFormDataMobileView = [{
        type: FormItemTypes.CardComponent,
        name: '',
        sx: {
            p: 0,
            pt: 2,
            border: 0,
            borderRadius: 0
        },
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                sx: {
                    border: "none"
                },
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        justifyContent: "center",
                        display: "flex",
                        mx: 2,
                        spacing: 0,
                        alignItems: 'center',
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: 'ads',
                                value: 'Parameters before repair',
                                fontWeight: 'bold',
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Chip,
                                name: "all",
                                label: '0',
                                sx: {
                                    ml: 1
                                },
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsB, _currentValue$ParamsB2;
                                    return {
                                        type: FormItemTypes.Chip,
                                        label: "".concat((_currentValue$ParamsB = currentValue === null || currentValue === void 0 || (_currentValue$ParamsB2 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB2 === void 0 ? void 0 : _currentValue$ParamsB2.length) !== null && _currentValue$ParamsB !== void 0 ? _currentValue$ParamsB : 0, "/5")
                                    };
                                },
                                columnSize: true,
                                color: "info"
                            }, {
                                type: FormItemTypes.Button,
                                name: 'AddParamsBeforeRepairData',
                                variant: 'text',
                                startIcon: /*#__PURE__*/ React.createElement(PlusBlueIcon, {
                                    color: "primary"
                                }),
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsB3, _currentValue$ParamsB4;
                                    return {
                                        type: FormItemTypes.Button,
                                        disabled: (currentValue === null || currentValue === void 0 || (_currentValue$ParamsB3 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB3 === void 0 ? void 0 : _currentValue$ParamsB3.length) > 4,
                                        startIcon: (currentValue === null || currentValue === void 0 || (_currentValue$ParamsB4 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB4 === void 0 ? void 0 : _currentValue$ParamsB4.length) > 4 ? /*#__PURE__*/ React.createElement(DisabledPlusIcon, null) : /*#__PURE__*/ React.createElement(PlusBlueIcon, null),
                                        sx: {
                                            display: !(currentValue !== null && currentValue !== void 0 && currentValue.ParamsBeforeRepairExpanded) ? "none" : null
                                        }
                                    };
                                },
                                setFormState: function (formValues, value) {
                                    var _formValues$ParamsBef;
                                    return {
                                        ParamsBeforeRepairData: __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.ParamsBeforeRepairData) || []), true), [{
                                                CheckedParams: "",
                                                Observations: "",
                                                Parameter: ((formValues === null || formValues === void 0 || (_formValues$ParamsBef = formValues.ParamsBeforeRepairData) === null || _formValues$ParamsBef === void 0 ? void 0 : _formValues$ParamsBef.length) || 0) + 1,
                                                IsBeforeRepair: 1,
                                                id: v4()
                                            }], false)
                                    };
                                },
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Button,
                                name: 'DelteParamsBeforeRepairData',
                                variant: 'text',
                                startIcon: /*#__PURE__*/ React.createElement(TrashIcon, null),
                                sx: {
                                    pr: 3
                                },
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsB5;
                                    var hasSelectedItem = currentValue === null || currentValue === void 0 || (_currentValue$ParamsB5 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB5 === void 0 ? void 0 : _currentValue$ParamsB5.some(function (item) { return item.Selected; });
                                    return {
                                        type: FormItemTypes.Button,
                                        startIcon: hasSelectedItem ? /*#__PURE__*/ React.createElement(TrashIcon, null) : /*#__PURE__*/ React.createElement(DisabledTrashIcon, null),
                                        disabled: !hasSelectedItem,
                                        sx: {
                                            display: !(currentValue !== null && currentValue !== void 0 && currentValue.ParamsBeforeRepairExpanded) ? "none" : null
                                        }
                                    };
                                },
                                setFormState: function (fromValues, value) {
                                    var _fromValues$ParamsBef;
                                    var filteredData = (fromValues === null || fromValues === void 0 || (_fromValues$ParamsBef = fromValues.ParamsBeforeRepairData) === null || _fromValues$ParamsBef === void 0 ? void 0 : _fromValues$ParamsBef.filter(function (item) { return !item.Selected; })) || [];
                                    var updatedData = filteredData.map(function (item, index) { return _objectSpread(_objectSpread({}, item), {}, {
                                        Parameter: index + 1
                                    }); });
                                    return {
                                        ParamsBeforeRepairData: updatedData
                                    };
                                },
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Button,
                                name: 'expand-button',
                                columnSize: 0,
                                color: 'secondary',
                                size: 'small',
                                sx: {
                                    p: 0,
                                    fontSize: 'sm'
                                },
                                setFormState: function (formValues) {
                                    return {
                                        ParamsBeforeRepairExpanded: !(formValues !== null && formValues !== void 0 && formValues.ParamsBeforeRepairExpanded)
                                    };
                                },
                                setFieldProps: function (formValues) {
                                    var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.ParamsBeforeRepairExpanded : !(formValues !== null && formValues !== void 0 && formValues.ParamsBeforeRepairExpanded);
                                    return {
                                        type: this.type,
                                        children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                    };
                                }
                            }]
                    }]
            }, {
                type: FormItemTypes.Accordian,
                name: 'ParamsBeforeRepairExpanded',
                value: false,
                summaryProps: {
                    sx: {
                        display: 'none'
                    }
                },
                summary: [],
                setFieldProps: function (formValues, currValue, field) {
                    return {
                        type: FormItemTypes.Accordian,
                        expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                    };
                },
                sx: {
                    bgcolor: 'background.secondary',
                    border: 'none'
                },
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.List,
                        name: 'ParamsBeforeRepairData',
                        columnSize: 12,
                        variant: 'compact',
                        value: null,
                        columns: [{
                                field: 'Parameter',
                                flex: 1,
                                renderCell: function (_ref) {
                                    var row = _ref.row;
                                    return /*#__PURE__*/ React.createElement(Typography, {
                                        p: 1,
                                        fontSize: 'md'
                                    }, "Parameter ".concat(row === null || row === void 0 ? void 0 : row.Parameter));
                                }
                            }],
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 12,
                                p: 1,
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Parameters checked',
                                        color: 'text.secondary'
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'CheckedParams',
                                        placeholder: 'Enter a description...',
                                        multiline: true,
                                        minRows: 4,
                                        validator: function (value) {
                                            var leadingSpacesRegex = /^\S.*$/;
                                            if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                                return "Leading spaces are not allowed.";
                                            }
                                            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || value.length > 250) {
                                                return "Parameters length must be between 10 and 250 characters.";
                                            }
                                            return undefined;
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Observations',
                                        color: 'text.secondary'
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'Observations',
                                        placeholder: 'Enter a description...',
                                        multiline: true,
                                        minRows: 4,
                                        validator: function (value) {
                                            var leadingSpacesRegex = /^\S.*$/;
                                            if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                                return "Leading spaces are not allowed.";
                                            }
                                            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || value.length > 250) {
                                                return "Observations length must be between 10 and 250 characters.";
                                            }
                                            return undefined;
                                        }
                                    }]
                            }],
                        getRowHeight: function () { return 'auto'; }
                    }]
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: 'ParamsWhileeRepairDataCard',
        sx: {
            p: 0,
            pt: 2,
            border: 0,
            borderRadius: 0
        },
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                sx: {
                    border: "none"
                },
                mx: 2,
                spacing: 0,
                columnSize: 12,
                containerProps: {
                    my: 0
                },
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        justifyContent: "center",
                        display: "flex",
                        spacing: 0,
                        alignItems: 'center',
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: 'ads',
                                children: 'Parameters while repair',
                                fontWeight: 'bold',
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Chip,
                                name: "ParamswhileRepairDataChip",
                                label: '0',
                                sx: {
                                    ml: 1
                                },
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsA, _currentValue$ParamsA2;
                                    return {
                                        type: FormItemTypes.Chip,
                                        label: "".concat((_currentValue$ParamsA = currentValue === null || currentValue === void 0 || (_currentValue$ParamsA2 = currentValue.ParamsAfterRepairData) === null || _currentValue$ParamsA2 === void 0 ? void 0 : _currentValue$ParamsA2.length) !== null && _currentValue$ParamsA !== void 0 ? _currentValue$ParamsA : 0, "/5")
                                    };
                                },
                                columnSize: true,
                                color: "info"
                            }, {
                                type: FormItemTypes.Button,
                                name: 'AddParamsAfterRepairData',
                                variant: 'text',
                                startIcon: /*#__PURE__*/ React.createElement(PlusBlueIcon, {
                                    color: "primary"
                                }),
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsA3, _currentValue$ParamsA4;
                                    return {
                                        type: FormItemTypes.Button,
                                        disabled: (currentValue === null || currentValue === void 0 || (_currentValue$ParamsA3 = currentValue.ParamsAfterRepairData) === null || _currentValue$ParamsA3 === void 0 ? void 0 : _currentValue$ParamsA3.length) > 4,
                                        startIcon: (currentValue === null || currentValue === void 0 || (_currentValue$ParamsA4 = currentValue.ParamsAfterRepairData) === null || _currentValue$ParamsA4 === void 0 ? void 0 : _currentValue$ParamsA4.length) > 4 ? /*#__PURE__*/ React.createElement(DisabledPlusIcon, null) : /*#__PURE__*/ React.createElement(PlusBlueIcon, null),
                                        sx: {
                                            display: !(currentValue !== null && currentValue !== void 0 && currentValue.ParamsWhileRepairDataExpanded) ? "none" : null
                                        }
                                    };
                                },
                                setFormState: function (formValues, value) {
                                    var _formValues$ParamsAft;
                                    return {
                                        ParamsAfterRepairData: __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.ParamsAfterRepairData) || []), true), [
                                            // Fallback to empty array if undefined
                                            {
                                                CheckedParams: "",
                                                Observations: "",
                                                Parameter: ((formValues === null || formValues === void 0 || (_formValues$ParamsAft = formValues.ParamsAfterRepairData) === null || _formValues$ParamsAft === void 0 ? void 0 : _formValues$ParamsAft.length) || 0) + 1,
                                                IsBeforeRepair: 1,
                                                id: v4()
                                            }], false)
                                    };
                                },
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Button,
                                name: 'DeleteParamsWhileRepairData',
                                variant: 'text',
                                startIcon: /*#__PURE__*/ React.createElement(TrashIcon, {
                                    color: "primary"
                                }),
                                sx: {
                                    pr: 3
                                },
                                setFieldProps: function (currentValue) {
                                    var _currentValue$ParamsA5;
                                    var hasSelectedItem = currentValue === null || currentValue === void 0 || (_currentValue$ParamsA5 = currentValue.ParamsAfterRepairData) === null || _currentValue$ParamsA5 === void 0 ? void 0 : _currentValue$ParamsA5.some(function (item) { return item.Selected; });
                                    return {
                                        type: FormItemTypes.Button,
                                        startIcon: hasSelectedItem ? /*#__PURE__*/ React.createElement(TrashIcon, null) : /*#__PURE__*/ React.createElement(DisabledTrashIcon, null),
                                        disabled: !hasSelectedItem,
                                        sx: {
                                            display: !(currentValue !== null && currentValue !== void 0 && currentValue.ParamsWhileRepairDataExpanded) ? "none" : null
                                        }
                                    };
                                },
                                setFormState: function (fromValues, value) {
                                    var _fromValues$ParamsAft;
                                    var filteredData = (fromValues === null || fromValues === void 0 || (_fromValues$ParamsAft = fromValues.ParamsAfterRepairData) === null || _fromValues$ParamsAft === void 0 ? void 0 : _fromValues$ParamsAft.filter(function (item) { return !item.Selected; })) || [];
                                    var updatedData = filteredData.map(function (item, index) { return _objectSpread(_objectSpread({}, item), {}, {
                                        Parameter: index + 1
                                    }); });
                                    return {
                                        ParamsAfterRepairData: updatedData
                                    };
                                },
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Button,
                                name: 'expand-button',
                                columnSize: 0,
                                color: 'secondary',
                                size: 'small',
                                sx: {
                                    p: 0,
                                    fontSize: 'sm'
                                },
                                setFormState: function (formValues) {
                                    return {
                                        ParamsWhileRepairDataExpanded: !(formValues !== null && formValues !== void 0 && formValues.ParamsWhileRepairDataExpanded)
                                    };
                                },
                                setFieldProps: function (formValues) {
                                    var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.ParamsWhileRepairDataExpanded : !(formValues !== null && formValues !== void 0 && formValues.ParamsWhileRepairDataExpanded);
                                    return {
                                        type: this.type,
                                        children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                    };
                                }
                            }]
                    }]
            }, {
                type: FormItemTypes.Accordian,
                name: 'ParamsWhileRepairDataExpanded',
                value: false,
                summaryProps: {
                    sx: {
                        display: 'none'
                    }
                },
                setFieldProps: function (formValues, currValue, field) {
                    return {
                        type: FormItemTypes.Accordian,
                        expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                    };
                },
                summary: [],
                sx: {
                    bgcolor: 'background.secondary',
                    border: 'none'
                },
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.List,
                        name: 'ParamsAfterRepairData',
                        columnSize: 12,
                        variant: 'compact',
                        value: null,
                        columns: [{
                                field: 'Parameter',
                                flex: 1,
                                renderCell: function (_ref2) {
                                    var row = _ref2.row;
                                    return /*#__PURE__*/ React.createElement(Typography, {
                                        p: 1,
                                        fontSize: 'md'
                                    }, "Parameter ".concat(row === null || row === void 0 ? void 0 : row.Parameter));
                                }
                            }],
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: 12,
                                p: 1,
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Parameters checked',
                                        color: 'text.secondary'
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'CheckedParams',
                                        placeholder: 'Enter a description...',
                                        multiline: true,
                                        minRows: 4,
                                        validator: function (value) {
                                            var leadingSpacesRegex = /^\S.*$/;
                                            if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                                return "Leading spaces are not allowed.";
                                            }
                                            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || value.length > 250) {
                                                return "Parameters length must be between 10 and 250 characters.";
                                            }
                                            return undefined;
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Observations',
                                        color: 'text.secondary'
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'Observations',
                                        placeholder: 'Enter a description...',
                                        multiline: true,
                                        minRows: 4,
                                        validator: function (value) {
                                            var leadingSpacesRegex = /^\S.*$/;
                                            if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                                return "Leading spaces are not allowed.";
                                            }
                                            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 10 || value.length > 250) {
                                                return "Observations length must be between 10 and 250 characters.";
                                            }
                                            return undefined;
                                        }
                                    }]
                            }],
                        getRowHeight: function () { return 'auto'; }
                    }]
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "failure/defective part",
        columnSize: 12,
        sx: {
            mx: {
                xs: 2,
                md: 0
            }
        },
        elements: [{
                type: FormItemTypes.TextInput,
                name: "CauseOfFailure",
                label: "Cause of Failure",
                md: 6,
                multiline: true,
                rows: 4,
                placeholder: "Enter your description",
                validator: function (value) {
                    if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                        return "Description cannot be less than of 10 character.";
                    }
                    else if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                        return "Description can have maximum of 250 character.";
                    }
                }
            }, {
                type: FormItemTypes.TextInput,
                name: "DefectivePartIdentification",
                label: "Defective part identification",
                md: 6,
                multiline: true,
                rows: 4,
                placeholder: "Enter your description",
                validator: function (value) {
                    if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                        return "Description cannot be less than of 10 character.";
                    }
                    else if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                        return "Description can have maximum of 250 character.";
                    }
                }
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "checksheet",
        columnSize: 12,
        sx: {
            mx: {
                xs: 2,
                md: 0
            },
            mb: 9
        },
        elements: [{
                type: FormItemTypes.Typography,
                name: "sub_heading",
                label: "Checksheet filled",
                labelTypographyProps: {
                    fontSize: "base",
                    fontWeight: "strong",
                    color: "text.primary"
                },
                children: "Manage your team members here",
                columnSize: true,
                color: "text.tertiary"
            }, {
                type: FormItemTypes.Attachment,
                name: "ChecksheetFilledAttachments",
                value: null,
                inputProps: {
                    accept: [".xlsx", ".xls", ".csv"]
                },
                columnSize: 0,
                attachmentButtonProps: {
                    sx: {
                        display: "none"
                    }
                },
                uploadAttachmentAPI: UploadAttachmentAPICall,
                setFieldProps: function (formValues, currentValue) {
                    var result = currentValue === null || currentValue === void 0 ? void 0 : currentValue.find(function (item) { return item.IsDeleted == 0 || (item === null || item === void 0 ? void 0 : item.name); });
                    return {
                        type: FormItemTypes.Attachment,
                        uploadButtonProps: {
                            variant: "text",
                            color: "primary",
                            disabled: result
                        }
                    };
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Custom,
                        name: "ChecksheetFilledAttachments",
                        columnSize: 12,
                        element: FileAttachmentComponent,
                        validator: function (value, state) {
                            var _value$2;
                            if ((value === null || value === void 0 || (_value$2 = value[0]) === null || _value$2 === void 0 ? void 0 : _value$2.size) > 5 * 1024 * 1024)
                                return "Max file size allowed is 5MB";
                            return "";
                        }
                    }]
            }]
    }];
